function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "09 - Illustration");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Main\\uD83D\\uDD25\\uD83D\\uDD25\\uD83D\\uDD25",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01---Home-(V.2)",
  transform: "translate(-1000.000000, -4381.000000)",
  fill: "#5257FF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Bloc_3",
  transform: "translate(0.000000, 1650.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blocs",
  transform: "translate(120.000000, 291.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "09---Illustration",
  transform: "translate(880.000000, 2440.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dots_3"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 1,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 9.66666667,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 18.3333333,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 27,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 35.6666667,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 44.3333333,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 53,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 61.6666667,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 70.3333333,
  cy: 79,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 9.66666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 18.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 27,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 35.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 44.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 61.6666667,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 70.3333333,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 79,
  cy: 79,
  r: 1
})))))));

var SvgDotPurple = function SvgDotPurple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotPurple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dot-purple.f586fb96.svg";
export { ForwardRef as ReactComponent };